import BaseApi from "../../../services/Api";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import React, {useEffect, useState} from "react";
import Tooltip from "../../Popups/Tooltip";
import {Modal, Spinner} from "react-bootstrap";
import Button from "../../Layout/Button";
import style from "./style.module.css"


const ModalPartners = ({
  idPartners, onUpdate, onCreate, children
}) => {
  const [isLoading, setLoading] = React.useState(true);
  const [isSaving, setSaving] = React.useState(true);
  const [isShow, setShowModal] = React.useState(false);

  const [name_partner, setName_partner] = useState('');
  const [icon, setIcon] = useState(null);
  const [updateIcon, setUpdateIcon] = useState(null);

  const [currentImage, setCurrentImage] = useState(null);

  const buildFormData = () =>{
    const formData = new FormData();
    if(name_partner!=undefined){

      formData.append("name_partner", name_partner)
    }
    
    if(idPartners){
      formData.append('_method', 'PUT')
      if (updateIcon) {
        formData.append("icon", updateIcon);
    }
    }else{
      if (icon){
        formData.append("icon", icon)
  
      }
    }
    return formData
  }

  const formData = buildFormData();

  const onSave = () => {
    Swal.fire({
      title: 'Certeza que deseja salvar?',
      text: "Você não conseguirá reverter isso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: "#198754",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitData();
      } else if (
          result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Operação cancelada!',
          showConfirmButton: false,
          timer: 1500
        })
      }
    })
  }

  const submitData = () => {
    setSaving(true);
    if (idPartners) {
      BaseApi.post(`/parceiros/${idPartners}`, formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Parceiro editado com sucesso!');
        onUpdate && onUpdate(res.data);
    }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados salvos com sucesso!',
          showConfirmButton: false,
          timer: 1500
        })
      }).catch(err => {
        Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || `${err?.response?.data?.message}`, 'error');
        setSaving(false);
      })
    }
    else {
      BaseApi.post('/parceiros', formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Informação de parceiro atualizada com sucesso');
        onCreate && onCreate(res.data);
    }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados salvos com sucesso!',
          showConfirmButton: false,
          timer: 1500
        })
      }).catch(err => {
        Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || `${err?.response?.data?.message}`, 'error');
        setSaving(false);
      })
    }
}

  const handleClose = () => {
    setShowModal(false);
  }

  const handleChangeIcon = (e) => {
    const selectedIcon = e.target.files[0];
    if (idPartners){
        if (selectedIcon)  {
            setUpdateIcon(selectedIcon);
            setCurrentImage(selectedIcon)
        }
    }
    else {
        if (selectedIcon)  {
            setIcon(selectedIcon);
            setCurrentImage(selectedIcon)
        }
    }
};

  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/parceiros${idPartners ? `/${idPartners}` : ''}`).then(res => {
      let data = res.data;
      setName_partner(data.name_partner);
      setIcon(data.icon)
      setCurrentImage(data.icon)
      setLoading(false);
      setSaving(false);
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar esta ação ou o parceiro não foi encontrado.', 'error');
      setShowModal(false);
    })
  }

  useEffect(() => {
    if(isShow) {
      requestData();
    } else {
      setName_partner('');
      setIcon(null);
      setUpdateIcon(null);
      setLoading(true);
      setSaving(true);
    }
  }, [isShow])

  return (
    <>
      {children &&
        React.cloneElement(children, { onClick: (e) => setShowModal(true) })}
      {!children && (
        <Tooltip text={idPartners ? "Editar parceiro" : "Criar parceiro"}>
          <button
            className={`btn btn-${idPartners ? "warning" : ""} text-white fa-bold`}
            onClick={(e) => setShowModal(true)}
          >
            <i className={`bi bi-${idPartners ? "person-gear" : "plus"}`}></i>
          </button>
        </Tooltip>
      )}
      <Modal
        centered
        scrollable
        onHide={handleClose}
        show={isShow}
        animation={true}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>{idPartners ? "Editar" : "Criar"} Parceiro</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center">
            {isLoading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
          {!isLoading && (
            <>
              <div className="row">
                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="name_partner">Parceiro </label> 
                  <input
                    type="text"
                    className="form-control"
                    id="name_partner"
                    placeholder="Insira o nome. obs.: max 30 caracteres"
                    value={name_partner}
                    onChange={(e) => setName_partner(e.target.value)}
                    maxlength="30"
                    
                  />
                </div>
                
                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="icon">Icone </label>

                  <input type="file" accept="icon/*"
                  className="form-control"
                  
                  onChange={handleChangeIcon} />
                  
                  {idPartners ? (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      <img
                        src={currentImage instanceof File ? URL.createObjectURL(currentImage) : currentImage}
                        alt="currentImage"
                        style={{ minWidth: 250, width: 350, objectFit: 'cover' }}
                      />
                    </div>
                  ) : 
                    null
                  }

                  {currentImage && !idPartners && (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      {idPartners ? <img src={currentImage} alt="currentImage" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                        : <img src={URL.createObjectURL(currentImage)} alt="currentImage" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                      }
                      </div>
                    )
                  }
                </div>


              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center w-100">
            <div className="d-block me-auto"></div>
            <div className="d-block ms-auto">
              <button
                className="btn btn-danger text-white me-2"
                onClick={handleClose}
              >
                Close
              </button>
              <Button
                loading={isSaving}
                onClick={onSave}
                className="btn btn-success text-white"
              >
                {idPartners ? "Editar" : "Criar"}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalPartners;